if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();
        this.lastAvailabilityRefresh = Date.now();
        this.cartRefreshUnsubscribe = webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.lastAvailabilityRefresh = Date.now();
        });
      }

      show(opener) {
        super.show(opener);
        if (Date.now() - this.lastAvailabilityRefresh > 15000) this.refreshAvailability();

        // Re-query DOM since cart content gets replaced on updates
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      hide() {
        super.hide();
        this.availabilityController?.abort();

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }

      async refreshAvailability() {
        if (this.availabilityController || window.SaiyisCart?.busy) return;
        this.availabilityController = new AbortController();
        const started = Date.now();
        const section = this.dataset.section;
        const controls = Array.from(this.querySelectorAll('button[name="checkout"], .quantity-input, .quantity-button')).map(element => ({element, disabled: element.disabled}));
        controls.forEach(({element}) => element.disabled = true);
        this.setAttribute('data-stock-refreshing', '');
        this.setAttribute('aria-busy', 'true');
        try {
          const url = window.location.pathname + '?sections=' + encodeURIComponent(section) + ',cart-icon-bubble';
          const response = await fetch(url, {cache:'no-store', signal:this.availabilityController.signal});
          if (!response.ok) return;
          const sections = await response.json();
          if (!sections[section] || this.lastAvailabilityRefresh > started || window.SaiyisCart?.busy) return;
          const targets = [
            {id:'Cart-Drawer', section, selector:'#Cart-Drawer-Details'},
            {id:'Cart-Drawer', section, selector:'.cart-count'}
          ];
          if (sections['cart-icon-bubble']) targets.push(
            {id:'Cart-Icon-Bubble',section:'cart-icon-bubble',selector:'.shopify-section'},
            {id:'Bottom-Cart-Bubble',section:'cart-icon-bubble',selector:'.shopify-section'}
          );
          SectionDynamicUpdate.updateSections(targets, sections);
          this.lastAvailabilityRefresh = Date.now();
        } catch (error) {
          // Retain the last rendered cart on offline/aborted refresh. Shopify revalidates checkout.
        } finally {
          controls.forEach(({element, disabled}) => {if (element.isConnected) element.disabled = disabled;});
          this.removeAttribute('data-stock-refreshing');
          this.removeAttribute('aria-busy');
          this.availabilityController = null;
        }
      }
    },
  );
}
